<script>
import { PermissionScope } from '@/shared/constants/permissions/PermissionScope'
import { mapGetters } from 'vuex'
import { PermissionModifier } from '@/shared/constants/permissions/PermissionModifier'

export default {
  name: 'TheCreateBookingBtn',
  props: {
    mini: {
      type: Boolean,
    },
  },
  computed: {
    ...mapGetters({
      hasPermissionRegardlessOfLevel: 'auth/hasPermissionRegardlessOfLevel',
    }),
    showCreateBookingButton() {
      return (
        this.hasPermissionRegardlessOfLevel(
          PermissionScope.BOOKING,
          PermissionModifier.CREATE
        ) ||
        this.hasPermissionRegardlessOfLevel(
          PermissionScope.PENDING_BOOKING,
          PermissionModifier.CREATE
        )
      )
    },
  },
}
</script>

<template>
  <section
    v-if="showCreateBookingButton"
    :class="[!mini ? 'px-4' : '', 'my-4 text-center']"
  >
    <v-tooltip :disabled="!mini" right>
      <template v-slot:activator="{ on }">
        <v-btn
          :fab="mini"
          :title="$t('booking.newBookingBtn')"
          color="blue"
          :block="!mini"
          :large="!mini"
          :small="mini"
          class="custom-elevation white--text rounded-lg"
          :to="{ name: 'bookings-create' }"
          v-on="on"
        >
          <v-icon :left="!mini">mdi-plus</v-icon>
          <span v-if="!mini"> {{ $t('booking.newBookingBtn') }} </span>
        </v-btn>
      </template>
      <span>{{ $t('booking.newBookingBtnTooltip') }}</span>
    </v-tooltip>
  </section>
</template>
